module.exports = __webpack_public_path__ + "img/gm-pu.9e8dba60.png";